function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_7553_701)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 27.2949,
  y: 78.2744,
  width: 13.6839,
  height: 7.84132,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 12.2344,
  y: 39.4399,
  width: 18.8285,
  height: 12.4539,
  rx: 3,
  fill: "#B6B9BB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 34.1377,
  y: 24,
  width: 46.1254,
  height: 62.1156,
  rx: 10,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9932 39.4399H34.1383V79.0429C34.1383 82.9489 30.9718 86.1154 27.0657 86.1154C23.1597 86.1154 19.9932 82.9489 19.9932 79.0429V39.4399Z",
  fill: "url(#paint0_linear_7553_701)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 45.4362C8 42.1246 10.6846 39.4399 13.9963 39.4399C17.308 39.4399 19.9926 42.1246 19.9926 45.4362V75.5715H18C12.4771 75.5715 8 71.0944 8 65.5715V45.4362Z",
  fill: "url(#paint1_linear_7553_701)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 40.2871,
  y: 53.9253,
  width: 33.8253,
  height: 11.774,
  rx: 4,
  fill: "#B6B9BB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 40.2871,
  y: 69.5752,
  width: 17.9889,
  height: 7.38007,
  rx: 3,
  fill: "#B6B9BB"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7553_701)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.3529 30.8911C44.5437 30.8911 40.6406 34.7942 40.6406 39.6034C40.6406 44.4125 44.5437 48.3156 49.3529 48.3156C54.162 48.3156 58.0651 44.4125 58.0651 39.6034C58.0651 34.7942 54.162 30.8911 49.3529 30.8911ZM49.3529 33.5048C50.7991 33.5048 51.9666 34.6722 51.9666 36.1185C51.9666 37.5647 50.7991 38.7321 49.3529 38.7321C47.9066 38.7321 46.7392 37.5647 46.7392 36.1185C46.7392 34.6722 47.9066 33.5048 49.3529 33.5048ZM49.3529 45.8762C47.1748 45.8762 45.2494 44.761 44.1255 43.0708C44.1517 41.3371 47.6104 40.3875 49.3529 40.3875C51.0866 40.3875 54.5541 41.3371 54.5802 43.0708C53.4563 44.761 51.5309 45.8762 49.3529 45.8762Z",
  fill: "#B6B9BB"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_7553_701)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 62.7129,
  y: 4,
  width: 32,
  height: 18,
  rx: 6,
  fill: "#B6B9BB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.311 24.5C80.1563 26.5 77.2695 26.5 76.1148 24.5L74.3828 21.5C73.2281 19.5 74.6714 17 76.9808 17L80.4449 17C82.7543 17 84.1977 19.5 83.043 21.5L81.311 24.5Z",
  fill: "#B6B9BB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9629 17.346C78.7349 17.346 78.5549 17.274 78.4229 17.13C78.3029 16.986 78.2309 16.782 78.2069 16.518L77.6669 9.642C77.6309 9.198 77.7269 8.844 77.9549 8.58C78.1829 8.304 78.5189 8.166 78.9629 8.166C79.3949 8.166 79.7189 8.304 79.9349 8.58C80.1629 8.844 80.2589 9.198 80.2229 9.642L79.6829 16.518C79.6709 16.782 79.5989 16.986 79.4669 17.13C79.3469 17.274 79.1789 17.346 78.9629 17.346ZM78.9629 21.09C78.5549 21.09 78.2249 20.964 77.9729 20.712C77.7329 20.46 77.6129 20.136 77.6129 19.74C77.6129 19.356 77.7329 19.044 77.9729 18.804C78.2249 18.552 78.5549 18.426 78.9629 18.426C79.3829 18.426 79.7069 18.552 79.9349 18.804C80.1749 19.044 80.2949 19.356 80.2949 19.74C80.2949 20.136 80.1749 20.46 79.9349 20.712C79.7069 20.964 79.3829 21.09 78.9629 21.09Z",
  fill: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_7553_701",
  x: 0,
  y: 20,
  width: 88.2627,
  height: 78.1157,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7553_701"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7553_701",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_7553_701",
  x: 54.7129,
  y: 0,
  width: 48,
  height: 38,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7553_701"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7553_701",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7553_701",
  x1: 20.9157,
  y1: 39.4399,
  x2: 34.1383,
  y2: 86.1154,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6B9BB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B9BB",
  stopOpacity: 0.43
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_7553_701",
  x1: 8,
  y1: 47.5443,
  x2: 19.9926,
  y2: 53.6944,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6B9BB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6B9BB",
  stopOpacity: 0.87
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7553_701"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20.9094,
  height: 20.9094,
  fill: "white",
  transform: "translate(38.8984 29.1484)"
})));

function SvgGreyNotFoundError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 99,
    viewBox: "0 0 103 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyNotFoundError);
export default __webpack_public_path__ + "static/media/GreyNotFoundError.2b6d3fe1.svg";
export { ForwardRef as ReactComponent };